import { useMutation } from '@apollo/client'
import { useAppDispatch } from '_store'
import classnames from "classnames";
import { AuthContext } from 'AuthContext'
import { EledoFormGenerator, EledoPageHeader, EledoPendingContent } from 'components/library'
import { useShowMenu } from 'hooks'
import { PlatformContext } from 'PlatformContext'
import React, { useContext } from 'react'
import { FormProvider, useForm } from 'react-hook-form'
import { Navigate, useLocation, useNavigate } from 'react-router-dom'
import ReactTooltip from 'react-tooltip'
import styles from 'components/library/EledoPageHeader.module.scss';
import { LoginPasswordFormModel } from 'model/login';
import { AuthenticateDataData, AuthenticateVars, GET_AUTHENTICATE } from 'graphql/AuthQueries';
import { setAllRequests } from '_reducers/puzzleRequests';

type LoginPasswordFormData = {
  password: string
  rememberMe: boolean
}

type LocationState = {
  userId: string
  email: string
  from: {
    pathname: string
    search: string
  }
}

const EledoLoginPassword = () => {
  const auth = useContext(AuthContext);
  const platform = useContext(PlatformContext);
  const navigate = useNavigate()
  const state = useLocation().state as LocationState;
  const email = state?.email

  const dispatch = useAppDispatch();
  const [doAuth, { loading, error }] = useMutation<AuthenticateDataData, AuthenticateVars>(GET_AUTHENTICATE, {
    onCompleted(data, clientOptions) {
      if(data){
        
        console.log(data)
        
        if(data){
          if((data.authenticate.accounts?.length || 0) > 0){
            return navigate("/login/accountSelect", { state: { ...state, ...clientOptions?.variables, accounts: data.authenticate.accounts }})
          }
          const authVars = clientOptions?.variables as AuthenticateVars
          
          auth.login(data.authenticate, authVars.type);
          
          if(data.authenticate.requests){
            dispatch(setAllRequests(data.authenticate.requests));
          }
// console.log(state.from)
          if(data.authenticate.user != null){
            if(state?.from?.pathname){
              navigate(state.from.pathname + state.from.search);
            }else{
              navigate("/templates/mine");
            }
          }
        }
      }
    },
    onError(error){
    }
  });
  
  // useEffect(() => {
  //   if(auth.user != null){
  //     if(state?.from?.pathname){
  //       navigate(state.from.pathname + state.from.search);
  //     }else{
  //       navigate("/templates/mine");
  //     }
  //   }
  // }, [platform, auth, navigate, state?.from?.pathname, state?.from?.search]);

  const formHandler = useForm<LoginPasswordFormData>({mode: "onChange"});
  const { formState: {isValid, isSubmitted} } = formHandler;

  useShowMenu();

  const onSubmitHandler = (data: LoginPasswordFormData) => {
    if(isValid) {
      platform.authService.provideAuthData()
        .then(provided => {
          
          const authenticate: AuthenticateVars = {
            userId: state.userId,
            type: "password",
            payload: data.password,
            rememberMe: data.rememberMe
          }
          
          doAuth({ variables: authenticate });
        })
    }
  }

  if(!auth.canLetLogin){
    return (
      <Navigate to={{pathname: '/start'}}/>
    )
  }

  if (!email) return <p>Missing email. Start over.</p>;

  return (
    <div>
      <EledoPageHeader/>

      <div className={classnames(styles.EledoLogin, "container")} data-testid="EledoLogin">
        <div className="section section-small">
          <div className="hero-paragraph text-center">
            <h2><b>Log in to your account</b></h2>
          </div>
          <FormProvider {...formHandler}>
            <form onSubmit={formHandler.handleSubmit(onSubmitHandler)}>
              <div style={{width: "20rem"}} className="center">
                <EledoFormGenerator formModel={LoginPasswordFormModel}
                                    editedDataObject={{}}/>

                <p style={{lineHeight: "100%", textAlign: "right"}}>
                  <a href="https://eledo.online/recovery" target="_blank" rel="noreferrer">Forgot your password?</a>
                </p>
                {error !== undefined && <span className="center text-center" style={{display: "block"}}>
                  <small className="error-message" style={{float: "initial"}}>{error.message}</small>
                </span>}

                <div className="hero-paragraph text-center">
                  <span data-tip={isSubmitted || isValid || loading ? "" : "Please check your credentials before logging in"}
                        data-for={isSubmitted || isValid || loading ? "" : 'login-button-tooltip'}>
                    <button className={"button"} type="submit"
                          {...(isValid ? {} : {"aria-disabled": "true"})}>
                      <EledoPendingContent state={loading}
                                          content="Login"
                                          pendingContent="Logging in..."/>
                    </button>
                  <ReactTooltip
                    id="login-button-tooltip"
                    place="right"
                    type="warning"
                    effect="float"
                    multiline={true}
                  />
                  </span>
                </div>


              </div>
            </form>
          </FormProvider>
        </div>
      </div>
    </div>
  )
}

export default EledoLoginPassword